import { LINKACCESSABILITY_SUCCESS, LINKACCESSABILITY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const linkaccessabilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case LINKACCESSABILITY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case LINKACCESSABILITY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default linkaccessabilityReducer;
